module.exports = __webpack_public_path__ + "static/media/2.de4b8819.png";